import { staticColors } from '../../../const/colors/staticColors';
export const getDynamicPinningTableBackground = ({ isPinned, }) => {
    return isPinned
        ? staticColors.dynamicTablePinnedColumnBackground
        : staticColors.dynamicTableUnpinnedColumnBackground;
};
